import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["TroopMeetingCard","CourtOfHonorCard"] */ "/workspace/packages/web/src/components/calendar/ClientEventCards.tsx");
